module.exports = __webpack_public_path__ + "img/undraw_delivery_address_03n0.e151b6ab.svg";